import { useCurrentTheme } from '../theming/useCurrentTheme';
import { createCommonStyles } from '../theming/styleConstants';
import { createShadows } from '../theming/shadows';

export const useCommonStyles = () => {
  const { theme } = useCurrentTheme();
  return {
    ...createCommonStyles(theme),
    shadows: createShadows(theme),
  };
};